module.exports = __webpack_public_path__ + "img/three-red-light.73f63ecd.svg";